// extracted by mini-css-extract-plugin
export default {"panel":"BarListPanel_panel__r-bor","title":"BarListPanel_title__JUOii","bars":"BarListPanel_bars__iaJhY"};